import FiltersSortHeaderWrapper from "components/Filters/SortHeader/Wrapper";
import FiltersSortHeaderSortableColumn from "components/Filters/SortHeader/SortableColumn";
import FiltersSortHeaderStaticColumn from "components/Filters/SortHeader/StaticColumn";
import useFiltersSortHeader from "components/Filters/SortHeader/useFiltersSortHeader";
import { makeSortableHeaderOption } from "components/Filters/SortHeader/helpers";
import Typography from "ds/components/Typography";

import { COLUMN_GAP, FilterItemKeys, COLUMN_ORDER } from "../constants";
import { FILTER_ITEMS_DICTIONARY } from "../constants";

const PolicyDetailsSamplesListLayoutHeader = () => {
  const { querySortOption, querySortDirection, onItemClick } = useFiltersSortHeader();

  return (
    <FiltersSortHeaderWrapper columnOrder={COLUMN_ORDER} columnGap={COLUMN_GAP}>
      <FiltersSortHeaderSortableColumn
        option={makeSortableHeaderOption(FilterItemKeys.CREATED_AT, FILTER_ITEMS_DICTIONARY)}
        querySortOption={querySortOption}
        querySortDirection={querySortDirection}
        onClick={onItemClick}
      />
      <FiltersSortHeaderStaticColumn>
        <Typography tag="span" variant="p-t6">
          Outcome
        </Typography>
      </FiltersSortHeaderStaticColumn>
    </FiltersSortHeaderWrapper>
  );
};

export default PolicyDetailsSamplesListLayoutHeader;
